/**
 * DrawMode is an enumeration of constant values that specify the
 * DrawMode to use when drawing.
 */
export class DrawMode
{
	/**
	 * Used to specify to draw both strokes and fills
	 */
	public static BOTH:number = 1;

	/**
	 * Used to specify to draw strokes only
	 */
	public static STROKE:number = 0;

	/**
	 * Used to specify to draw fills only
	 */
	public static FILL:number = 2;
}